<template>
  <!-- deviceDetection 设备监测-->
  <div class="energy-flow">
    <div class="con">
      <div class="tree-left">
        <div class="search">
          <el-input placeholder="输入关键字进行过滤" v-model="filterTextRight"></el-input>
        </div>
        <div class="scroll" style="width:100%;height:93%">
          <el-scrollbar style="height:100%;width: 100%;">
            <el-tree :data="rightData" node-key="id" :props="defaultProps" :filter-node-method="filterNodeRight"
              ref="tree" default-expand-all>
              <span class="custom-tree-node" slot-scope="{node}">
                <img src="../../../public/static/image/elTree/1.9.png" v-if="node.data.entityName=='AppClassType'" />
                <img src="../../../public/static/image/elTree/2.1.png" v-else />
                <span style="padding-left: 5px;">{{node.label}}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>

      </div>
      <div class="content">
        <el-form :model="temp" ref="temp" :rules="rules" style="width: 95%; padding-top: 10px;margin-bottom: 70px;"
          label-width="160px">
          <el-form-item label="设备名称：" prop="deviceClassificationName">
            <span style="font-weight: bold;font-size: 16px;"> {{unitItem.Content&&unitItem.Content.Name}}</span>
          </el-form-item>
          <el-form-item label="电流互感器变比值：" prop="ratioValue">
            <el-input v-model="temp.ratioValue" type="number" placeholder="请输入电流互感器变比值"
              style="width: 300px;"></el-input>
            <el-button type="primary" @click="submit" :disabled="!temp.deviceNo" style="margin-left: 10px;">发 送
            </el-button>
          </el-form-item>
          <el-form-item label="电压互感器变比值：" prop="newratioValue">
            <el-input v-model="temp.newratioValue" type="number" placeholder="请输入电压互感器变比值"
              style="width: 300px;"></el-input>
            <el-button type="primary" @click="newsubmit" :disabled="!temp.deviceNo" style="margin-left: 10px;">发 送
            </el-button>
          </el-form-item>
          <el-form-item label="">

          </el-form-item>
        </el-form>

      </div>
    </div>


  </div>
</template>

<script>

  import {getReadDeviceTree} from "../../api/abbNewApi";
  import Pagination from "@/components/module/Pagination"; // 分页
  import request from "@/api/http.js";
  export default {
    components: {Pagination},
    data () {
      return {
        rightData: [{
          children: [{
            no: 11,
            pkid: "0f92bc3ddfa541c0816c417997d8a727",
            archivesTypeCode: null,
            parentarea: 0,
            channel: 3,
            archivesId: null,
            sort: 1,
            type: "virtualDevice",
            entityno: -1,
            deviceaddr: 1,
            createTime: null,
            entityName: "VirtualDevicePojo",
            label: "表101-麦当劳-1楼低压电房",
            id: "11",
            deviceState: 1
          },{
            no: 12,
            pkid: "4979ccdc7dcd4e9a8521a7e797c3e2f6",
            archivesTypeCode: null,
            parentarea: 0,
            channel: 3,
            archivesId: null,
            sort: 2,
            type: "virtualDevice",
            entityno: -1,
            deviceaddr: 2,
            createTime: null,
            entityName: "VirtualDevicePojo",
            label: "表102-麦当劳-1楼低压电房",
            id: "12",
            deviceState: 1
          },{
            no: 13,
            pkid: "62cb2f82a5a14dc1a051bf5bb4d17618",
            archivesTypeCode: null,
            parentarea: 0,
            channel: 3,
            archivesId: null,
            sort: 3,
            type: "virtualDevice",
            entityno: -1,
            deviceaddr: 13,
            createTime: null,
            entityName: "VirtualDevicePojo",
            label: "表103-蜜雪冰城-1楼低压电房",
            id: "13",
            deviceState: 1
          },{
            no: 14,
            pkid: "1ca3f7465fa6455e886b7cae552351d2",
            archivesTypeCode: null,
            parentarea: 0,
            channel: 3,
            archivesId: null,
            sort: 4,
            type: "virtualDevice",
            entityno: -1,
            deviceaddr: 14,
            createTime: null,
            entityName: "VirtualDevicePojo",
            label: "表104-蜜雪冰城-1楼低压电房",
            id: "14",
            deviceState: 1
          },{
            no: 16,
            pkid: "c0272c4d12b442e8a5d26ffdb57578e9",
            archivesTypeCode: null,
            parentarea: 0,
            channel: 3,
            archivesId: null,
            sort: 6,
            type: "virtualDevice",
            entityno: -1,
            deviceaddr: 16,
            createTime: null,
            entityName: "VirtualDevicePojo",
            label: "表106-蜜雪冰城-1楼低压电房",
            id: "16",
            deviceState: 1
          },{
            no: 21,
            pkid: "636698dd7be74568abc73ea00c893a82",
            archivesTypeCode: null,
            parentarea: 0,
            channel: 5,
            archivesId: null,
            sort: 1,
            type: "virtualDevice",
            entityno: -1,
            deviceaddr: 17,
            createTime: null,
            entityName: "VirtualDevicePojo",
            label: "表201-悦熹楼-1楼低压电房",
            id: "21",
            deviceState: 1
          },{
            no: 18,
            pkid: "1e32f4d7ab924974a44c45b3a3eb3efa",
            archivesTypeCode: null,
            parentarea: 0,
            channel: 5,
            archivesId: null,
            sort: 2,
            type: "virtualDevice",
            entityno: -1,
            deviceaddr: 18,
            createTime: null,
            entityName: "VirtualDevicePojo",
            label: "表202-南岗-1楼低压电房",
            id: "18",
            deviceState: 1
          },{
            no: 19,
            pkid: "9b456c50c2814e869a3c39ea543bb9ea",
            archivesTypeCode: null,
            parentarea: 0,
            channel: 5,
            archivesId: null,
            sort: 3,
            type: "virtualDevice",
            entityno: -1,
            deviceaddr: 19,
            createTime: null,
            entityName: "VirtualDevicePojo",
            label: "表203-南岗-2楼低压电房",
            id: "19",
            deviceState: 1
          },{
            no: 20,
            pkid: "0de6a89bf67a4b2587b5b64e57cdf1df",
            archivesTypeCode: null,
            parentarea: 0,
            channel: 5,
            archivesId: null,
            sort: 4,
            type: "virtualDevice",
            entityno: -1,
            deviceaddr: 20,
            createTime: null,
            entityName: "VirtualDevicePojo",
            label: "表204-悦熹楼-2楼低压电房",
            id: "20",
            deviceState: 1
          }],
          no: 4,
          fatherno: 3,
          pkid: "4",
          createTime: null,
          entityName: "AppClassType",
          label: "商场",
          unitid: "0A200022945047D7A5E538EDFC40FA2A",
          id: "4",
          sort: 2,
          type: "group",
          devicetype: 0
        }],//右边树形结构树形
        tag_flag: false,
        currentSize: 10,
        currentPage: 1,
        heights: document.getElementById('app').clientHeight-140,
        loading: false,
        dialogStatus: "新增",//弹窗类型
        radio: "能流分析",//单选框
        selectData: [],
        leftData: [],//左边树形结构数据 
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        filterText: '',
        filterTextRight: "",
        tableData: [],
        multipleSelection: [],
        rules: {
          ratioValue: [
            {required: true,message: '请输入变比值',trigger: 'blur'}
          ],
          newratioValue: [
            {required: true,message: '请输入变比值',trigger: 'blur'}
          ],

        },
        temp: {
          deviceNo: "",
          ratioValue: "",
          newratioValue: "",
          userCode: localStorage.getItem("nowWedoSystemUserCode"),
        },
        dialogVisible: false,
        unitItem: {},
        tag: 1,//判断点击的是单位/能流图/节点
        nodeItem: [],//节点
        checkedNodes: [],
        halfCheckedNodes: null,
        nowNode: "",
        defaultExpanded: [],
        defaultDevice: "",
        firstItem: "",
      }
    },
    watch: {
      'temp.deviceTypeId': function(val) {
        if(val==''||!val) {
          this.temp.deviceTypeId=''
          return
        }
        // deviceTypeName
        this.selectData.map(v => {
          if(val==v.id) {
            this.temp.deviceTypeName=v.deviceTypeName||this.temp.deviceClassificationName;
          }
        })

      },
      filterText (val) {
        this.$refs.leftTree.filter(val);
      },
      filterTextRight (val) {
        this.$refs.tree.filter(val);
      },
      unitId () {
        this.findUnitInfoFun()
      }

    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      }
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    },
    mounted () {
      var num=0


    },
    beforeDestroy () {
      this.nodeItem=[]
    },
    methods: {
      aaaa (v) {
        console.log(v,122);
      },
      submit () {

        if(!this.temp.ratioValue) {
          this.$message({message: '请输入变比值',type: 'info'});
          return
        }
        this.temp.ratioValue=Number(this.temp.ratioValue);
        var params={
          'ctType': "5",
          'deviceNo': this.temp.deviceNo,
          'ratioValue': this.temp.ratioValue,
          'userCode': localStorage.getItem("nowWedoSystemUserCode"),
        };

        request({url: "/ct/settingCT",method: "get",params}).then(res => {
          if(res.code==200) {
            this.$message({message: '发送成功',type: 'success'});
          } else {
            res.message? this.$message({message: res.message,type: 'error'}):this.$message({message: '发送失败！！！',type: 'error'})
          }
        })
      },
      newsubmit () {
        if(!this.temp.newratioValue) {
          this.$message({message: '请输入变比值',type: 'info'});
          return
        }
        this.temp.newratioValue=Number(this.temp.newratioValue);
        var params={
          'ctType': "6",
          'deviceNo': this.temp.deviceNo,
          'ratioValue': this.temp.newratioValue,
          'userCode': localStorage.getItem("nowWedoSystemUserCode"),
        };

        request({url: "/ct/settingCT",method: "get",params}).then(res => {
          if(res.code==200) {
            this.$message({message: '发送成功',type: 'success'});
          } else {
            res.message? this.$message({message: res.message,type: 'error'}):this.$message({message: '发送失败！！！',type: 'error'})
          }
        })
      },
      //左边树形结构筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.deviceClassificationName.indexOf(value)!==-1;
      },
      //右边树形结构筛选
      filterNodeRight (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },
      //表格全选反选
      toggleSelection (rows) {
        if(rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange (val) {
        this.multipleSelection=val;
      },
      //左边树形结构数据
      findUnitInfoFun () {
        var params={
          unitId: this.unitId.id
        }
        request({url: "/deviceClassification/getAllByUnitId",method: "get",params}).then(res => {
          var d=res.data[0];
          if(res.code==200) {
            this.leftData=res.data;
            if(this.leftData.length) {
              this.getDeviceList({id: this.leftData[0].id})
            }

          }
        })
      },
      //左边数据结构点击
      leftTreeClick (item) {

        if(item.Content.Category=="Device") {
          console.log(item,11);
          this.unitItem=item;
          this.temp.deviceNo=Number(item.Id)
        }

        // this.getDeviceList(item)
      },
      //获取能流图列表
      getDeviceList (v) {
        var params={
          id: v.id,
          pageIndex: this.currentPage,
          pageSize: this.currentSize,
        }
        request({url: "/deviceClassification/getDevicesByDeviceClassificationId",method: "get",params}).then(res => {
          if(res.code==200) {
            this.tableData=res.data.content;
            this.total=res.data.totalElements;
          }
        })
      },
      //弹窗
      popupFn (type) {
        var params={
          unitId: this.unitId.id
        }

        this.dialogVisible=true
        if(type=='add') {
          this.dialogStatus="新增"
          this.temp={
            deviceClassificationName: '',
            deviceTypeId: '',
            unitId: this.unitId.id
          }

        } else if(type=='eait') {
          this.dialogStatus="修改"
          this.temp=Object.assign({},this.unitItem)

        }
      },
      //添加成功提示
      addSuccess (type) {
        if(type=='新增') {
          this.$message({type: 'success',message: '添加成功!'});
        } else {
          this.$message({type: 'success',message: '修改成功!'});
        }
        this.findUnitInfoFun()
        this.temp.modelName=""
        this.temp.modelType=""
        this.dialogVisible=false
      },
      //新增修改
      determine_Fn (type) {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            if(type=='新增') {
              //新增模型 
              var data=this.temp;
              request({url: "/deviceClassification/save",method: "post",data}).then(res => {
                if(res.code==200) {
                  this.addSuccess(type)
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('添加失败')
                }
              })
            } else if(type=='修改') {
              var data=this.temp;
              data.uid=data.id;
              request({url: "/deviceClassification/save",method: "post",data}).then(res => {
                if(res.code==200) {
                  this.addSuccess(type)
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('修改失败')
                }
              })
              // updateDissipation(this.temp).then(res => {
              //   if(res.code==200) {
              //     this.addSuccess(type)
              //   } else {
              //     res.message? this.$message.error(res.message):this.$message.error('修改失败')
              //   }
              // })
            }

          } else {
            return false;
          }
        });


      },
      //删除操作
      delFun () {
        if(this.unitItem.length==0) {
          this.$message({type: 'warning',message: '请选择节点'});
          return
        }

        this.$confirm(`是否删除该 ${this.unitItem.deviceClassificationName}?`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params={
            id: this.unitItem.id
          }
          request({url: "/deviceClassification/delete",method: "delete",params}).then(res => {
            if(res.code==200) {
              this.findUnitInfoFun()
              this.$message({type: 'success',message: `删除 ${this.unitItem.deviceClassificationName} 成功!`});
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      //移除能流图节点的关联设备
      device_Del () {
        // console.log("this.multipleSelection",this.multipleSelection);
        if(this.multipleSelection.length==0) {
          this.$message({type: 'warning',message: '请勾选需要删除的设备!'});
          return
        }
        var ids=""
        this.multipleSelection.forEach(item => ids+=','+item.virtualDeviceNo)


        var params={
          "noes": ids.slice(1),
          "id": this.unitItem.id
        }

        request({url: "/deviceClassification/deleteDeviceByClassification",method: "DELETE",params}).then(res => {
          console.log(res,'res');
          if(res.code==200) {
            this.$message({type: 'success',message: '移除成功!'});
            this.findUnitInfoFun();
            this.getDeviceList({id: this.unitItem.id})
          } else {
            this.$message({type: 'error',message: `移除失败,${res.message}`});
          }
        })
        // dissipationRemove(d).then(res => {
        //   if(res.code==200) {
        //     this.$message({type: 'success',message: '移除成功!'});
        //     this.getDeviceList({id: this.unitItem.id})
        //   } else {
        //     this.$message({type: 'error',message: `移除失败,${res.message}`});
        //   }
        // })

      },
      //树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {
        var mycheckedNodes=SelectedObj.checkedNodes
        this.checkedNodes=mycheckedNodes.filter(item => item.Content.Category=='Device')
      },
      //添加能流图节点的关联设备
      device_Add () {
        //  console.log(this.nodeItem);
        if(!this.unitItem.id) {
          this.$message({type: 'warning',message: '请选择节点!'});
          return
        }
        if(this.checkedNodes.length==0) {
          this.$message({type: 'warning',message: '请勾选需要添加的设备!'});
          return
        }
        var devices=[]
        this.checkedNodes.forEach(item => {
          devices.push(item.Content.Id)
        })
        var params={
          "noes": devices.join(','),
          "id": this.unitItem.id
        }

        request({url: "/deviceClassification/saveDeviceByClassification",method: "post",params}).then(res => {
          console.log(res,'res');
          if(res.code==200) {
            this.checkedNodes=[];
            this.$refs.tree.setCheckedKeys([]);
            this.$message({type: 'success',message: '添加成功!'});
            this.findUnitInfoFun();
            this.getDeviceList({id: this.unitItem.id})
          } else {
            this.$message({type: 'error',message: `添加失败! ${res.message}`});
          }
        })
        // dissipationSave(d).then(res => {
        //   //  console.log("res添加设备",res);
        //   if(res.code==200) {
        //     this.$message({type: 'success',message: '添加成功!'});
        //     this.checkedNodes=[]
        //     this.$refs.tree.setCheckedKeys([]); 
        //   } else {
        //     this.$message({type: 'error',message: `添加失败! ${res.message}`});
        //   }
        // })



        // console.log("checkedNodes",this.checkedNodes);
        // console.log("12131",this.nodeItem);
      },

      //分页功能
      newgetNowPageDataList () {
        this.getDeviceList({id: this.unitItem.id})

      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }
    },
  }
</script>

<style lang='scss' scoped>
  .content {
    padding-top: 20px;
  }

  .p {
    display: flex;
    justify-content: space-between;
  }

  .clearfix {
    display: flex;
  }

  .clearfix>.left {
    margin-right: 20px;
  }

  .clearfix>.right {
    flex: 1;
    font-size: 20px;
    font-weight: bold;
  }

  .clearfix>.right p {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .card_box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

  }

  .card_box .box-card {
    width: calc(20% - 10px);
    box-sizing: border-box;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .card_box .box-card:nth-child(n*5) {
    margin-right: 0;
  }

  .tag_box {
    margin: 5px;
    margin-left: 20px;
  }

  .tag_box>span {
    cursor: pointer;
  }

  .energy-flow {
    width: 100%;
    padding: 8px;
  }

  .con {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    overflow: hidden;

    .con-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      margin-left: 10px;
      margin-top: 20px;

      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 20px 12px 12px 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }

    }

    .content {
      // flex-grow: 1;
      width: calc(100% - 3rem);
      background-color: #fff;
      border-right: 1px solid #e6e6e6;

      .content-title {
        margin-left: 20px;
        margin-top: 20px;
        font-size: 16px;
        color: #999;
      }

      .mytable {
        width: 100%;
        box-sizing: border-box;
        margin: 20px 20px 0px 20px;
      }

      .conten-btns {
        margin-top: 200px;

        // button {
        //    margin-bottom: 20px;
        // }
        div {
          width: 0.88rem;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          border-radius: 2px;
          background-color: #409EFF;
          color: #fff;
          margin-bottom: 40px;
          cursor: pointer;

          img {
            width: 0.2rem;
            height: 0.2rem;
            margin-left: 0.1rem;
          }
        }

      }
    }

    .tree-right {
      width: 3rem;
      height: 100%;
      background-color: #fff;
      padding: 20px 12px 12px 20px;
      box-sizing: border-box;
    }
  }
</style>